/**************************************************
 * Nombre:       Formulario_Galeria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {EventAvailable, EventOutlined, Flag, TitleOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSEVENTO} from "../../Constantes";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import {useEffect, useState} from "react";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";

const Formulario_Galeria = ({...props}) => {
    const [eventos, setEventos] = useState([]);


    useEffect(() => {

        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'galeriaFotos', wheres: w}).then((dox) => {

            let arr = dox.data
            let set = new Set(arr.map((item) => item.evento))
            let newArr = new Array(...set)
            setEventos(newArr);
        })

    }, []);

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Typography>Cualquier dimencion (maximo 300kb)</Typography>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagen dato={'img'} {...props} ancho={2} alto={3}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSEVENTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={EventAvailable} nombre={'Evento'} dato={'evento'} {...props}
                                   opciones={eventos}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={EventOutlined} nombre={'Nuevo Evento'} dato={'nuevoEvento'} {...props}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'} dato={'descripcion'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Galeria